import { Tooltip, Group, Text } from "@mantine/core";
import { HiInformationCircle } from "react-icons/hi2";
import CustomSelect from "../../ui/CustomSelect/CustomSelect";
import { optionsFilterByLabel } from "../../../utils/optionsFilter";

const ObjectSelect = ({
  value,
  onChange,
  options,
  isLoading = false,
  disabled = false,
  ...selectProps
}) => {
  const selectValue =
    typeof value === "string" ? value || null : value?.code || null;
  const handleChange = (selectedValue) => {
    if (!selectedValue) {
      if (typeof onChange === "function") {
        onChange(null);
      }
      return;
    }

    const selectedOption = options.find((o) => o.value === selectedValue);
    if (selectedOption && typeof onChange === "function") {
      onChange({
        code: selectedOption.value,
        description: selectedOption.label,
      });
    } else if (typeof onChange === "function") {
      onChange(null);
    }
  };

  const hasTooltips = options.some((opt) => opt.longDescription);

  const renderOption = hasTooltips
    ? ({ option }) => {
        if (option.longDescription) {
          return (
            <Group gap="xs" wrap="nowrap" justify="space-between" w="100%">
              <Text size="sm">{option.label}</Text>
              <Tooltip
                label={option.longDescription}
                position="right"
                withArrow
                multiline
                maw={250}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  <HiInformationCircle
                    size={16}
                    color="var(--mantine-color-gray-5)"
                  />
                </span>
              </Tooltip>
            </Group>
          );
        }
        return <Text size="sm">{option.label}</Text>;
      }
    : undefined;

  return (
    <CustomSelect
      {...selectProps}
      value={selectValue}
      onChange={handleChange}
      data={options}
      searchable
      lockOnSelect
      comboboxProps={{
        withinPortal: false,
      }}
      filter={optionsFilterByLabel}
      disabled={disabled || isLoading}
      renderOption={renderOption}
    />
  );
};

export default ObjectSelect;
